import { useNavigate } from 'react-router-dom';
import { IconChevronLeft } from '@tabler/icons-react';
import { ClientsTable } from '../ClientsTable';
import { useFamily } from '../hooks/useFamily';
import { useClientsContext } from 'src/clients/context/ClientsContext';

export function FamilyClientsTable({ id }: { id: string }) {
  const { family } = useFamily(id);
  const navigate = useNavigate();
  const title = [family?.name, 'Family'].filter(Boolean).join(' ');
  const { editFamily } = useClientsContext();

  return (
    <ClientsTable
      title={title}
      titleIcon={<IconChevronLeft />}
      onTitleClick={() => {
        navigate(`/clients/families`);
      }}
      filters={{ familyId: id }}
      showViewModes={false}
      primaryButton={{
        label: 'Edit client',
        variant: 'default',
        onClick: () => {
          if (family) {
            editFamily(family.id);
          }
        },
      }}
    />
  );
}
